import { createContext, useContext } from 'react';
import type { AlignmentGuide } from './card-resize';

export interface CardResizeSession {
  readonly setGuides: (guides: readonly AlignmentGuide[]) => void;
}

export const CardResizeSessionContext = createContext<CardResizeSession | null>(null);

export function useCardResizeSession(): CardResizeSession | null {
  return useContext(CardResizeSessionContext);
}
